import { render, staticRenderFns } from "./Layout-content.vue?vue&type=template&id=3727a5dc&scoped=true"
import script from "./Layout-content.vue?vue&type=script&lang=js"
export * from "./Layout-content.vue?vue&type=script&lang=js"
import style0 from "./Layout-content.vue?vue&type=style&index=0&id=3727a5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3727a5dc",
  null
  
)

export default component.exports